<template>
	<div class="flex w-full flex-col bg-gray-100 lg:flex-row">
		<div class="lg:w-1/2 lg:pr-10">
			<h2 class="w-full">How does car finance work?</h2>
			<div class="w-full">
				<div class="space-y-4 text-lg text-gray-575">
					Thinking about buying a car on finance? Simply compare 30+
					lenders in just 60 seconds. You can also find out about
					personalised repayments with no impact to your credit score.
				</div>

				<div class="w-full">
					<CarbarImage
						image="img/finance/img-car_finance_work.webp"
						alt-text="How car financing works"
					/>
				</div>
			</div>
		</div>
		<div class="flex flex-col lg:w-1/2 lg:pl-5 xl:pl-10">
			<div>
				<div
					v-for="(list, index) in Lists"
					:key="index"
					class="relative mt-8"
				>
					<div class="flex flex-col">
						<h3 class="font-body font-medium text-gray-700">
							{{ '0' + (index + 1) }}.
						</h3>
						<h3 class="font-body font-medium text-gray-700">
							{{ list.head }}
						</h3>
						<div class="text-lg text-gray-575">
							{{ list.content }}
						</div>
					</div>
					<div class="absolute bottom-0 right-0 top-0 flex">
						<div
							class="font-heading text-[100px] font-bold leading-tight text-gray-400 opacity-20"
						>
							{{ index + 1 }}
						</div>
					</div>
				</div>
				<CarClarityCalculators id="car_clarity_widget_3" variant="2" />
				<TrustPilotMicro />
			</div>
		</div>
	</div>
</template>

<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import CarClarityCalculators from '@/components/modals/carClarity/CarClarityCalculators.vue'
import TrustPilotMicro from '@/components/trustpilot/TrustPilotMicro.vue'

const props = defineProps({
	icon: {
		type: String,
		default: 'img/common/ico-arrow_down.svg',
		required: false,
	},
})

const Lists = [
	{
		head: 'Ask for a match',
		content:
			'Simply fill in some details about you, the carbar car & the loan to get matched to your top 3 most suitable lenders available within CarClarity.',
	},
	{
		head: 'Compare lenders',
		content:
			'You can view details such as loan interest, comparison rates, loan features and fees all on the one dashboard.',
	},
	{
		head: 'CarClarity does the groundwork',
		content:
			'Once you’ve found the right carbar car, we carry out all the checks - so you can move forward with peace of mind and buy with confidence.',
	},
	{
		head: 'Get approved',
		content:
			'Now that you have your carbar car and all the checks are completed, the application process is finalised.',
	},
]
</script>
